import { ComponentType, useMemo } from 'react'

import { useMediaQuery } from '@lounge-fe/ui-kit/src/hooks'

import { FilterByProps } from '../types'
import { FilterByDesktop } from './FilterByDesktop'
import { FilterByMobile } from './FilterByMobile'

export const FilterBy = ({ name, sections }: FilterByProps) => {
  const isDesktop = useMediaQuery(({ screens }) => `(min-width: ${screens.md})`)

  const FilterByComponent = useMemo<ComponentType<FilterByProps>>(
    () => (isDesktop ? FilterByDesktop : FilterByMobile),
    [isDesktop],
  )

  return (
    <div
      className="
        relative flex flex-1 items-center md:flex-grow-0 
        whitespace-nowrap border-r border-primary-default"
    >
      <FilterByComponent name={name} sections={sections} />
    </div>
  )
}
